<template>
    <div class="el-table-container templateBox">
        <el-form size="small" :inline="true" class="query-form" ref="searchForm" :model="searchForm"
                 @keyup.enter.native="refreshList(1,1,1)" @submit.native.prevent>
            <el-form-item prop="content" label-width="0px">
                <el-input v-model.trim="searchForm.content" maxlength="50" placeholder="请输入文件水印关键字"
                          clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="refreshList(1,1,1)" size="small" icon="el-icon-search">查询</el-button>
                <el-button @click="reset()" size="small" icon="el-icon-refresh-right">重置</el-button>
            </el-form-item>
            <el-form-item class="f_r">
                <el-button v-if="hasPermission('supervise:ownership:list:add')" type="primary" @click="addWatermark()"
                           size="small">新增
                </el-button>
                <el-button v-if="hasPermission('supervise:ownership:list:deleteWatermark')" type="primary"
                           @click="deleteWatermark()" size="small">删除
                </el-button>
            </el-form-item>
        </el-form>
        <div class="dataBox">
            <el-table
                    :data="dataList"
                    v-loading="loading"
                    size="small" height="100%"
                    class="table" border
                    ref="multipleTable"
                    :row-key="'id'"
                    @sort-change="sortChange"
                    @selection-change="selectionChangeHandle"
            >
                <el-table-column :reserve-selection="true" type="selection" width="50"/>
                <el-table-column prop="watermarkingContent" label="文件水印" show-overflow-tooltip></el-table-column>
                <el-table-column prop="status" label="状态" show-overflow-tooltip>
                    <template slot-scope="{row}">
                        <el-switch
                                v-model="row.status"
                                active-value="0"
                                @change="setType(row)"
                                inactive-value="1">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column prop="createByName" label="添加人" show-overflow-tooltip></el-table-column>
                <el-table-column prop="createTime" label="添加时间" sortable="custom" show-overflow-tooltip></el-table-column>
                <el-table-column prop="updateTime" label="最后修改时间" sortable="custom" show-overflow-tooltip></el-table-column>
                <el-table-column fixed="right" label="操作">
                    <template slot-scope="{row}">
                        <el-button v-if="hasPermission('supervise:ownership:list:edit')" type="text" size="small"
                                   @click="addWatermark(row)">编辑
                        </el-button>
                        <el-button v-if="hasPermission('supervise:ownership:list:deleteWatermark')" type="text"
                                   size="small" @click="deleteWatermark(row)">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <pagination :total="total" :page.sync="searchForm.current" :limit.sync="searchForm.size"
                    @pagination="refreshList"/>
        <add-watermark ref="addWatermark" @refresh="refreshList(1,1)"></add-watermark>
    </div>
</template>

<script>
import AddWatermark from "@/views/modules/supervise/ownership/addWatermark.vue";

export default {
    name: "list",
    components: {AddWatermark},
    data() {
        return {
            searchForm: {
                content: '',
                current: 1,
                size: 20,
            },
            total: 0,
            sort:'',
            loading: false,
            dataList: [],
            dataListSelect: [],
        }
    },

    mounted() {
        this.refreshList()
    },

    methods: {
        // 获取数据列表 current查第几页数据
        refreshList(type, clearSelect,sort) {
            if (type == 1) {
                this.searchForm.current = 1
            }
            if (clearSelect) {
                this.$refs.multipleTable.clearSelection()
            }
            if (sort) {
                this.$refs.multipleTable.clearSort()
            }
            this.loading = true
            this.$axios(this.api.allCommon.commonWatermarkList, {
                ...this.searchForm,
                sort:this.sort,
            }).then(data => {
                if (data && data.status) {
                    this.dataList = data.data.records
                    if (this.dataList.length == 0 && this.searchForm.current > 1) {
                        this.searchForm.current--
                        this.refreshList()
                    }
                    this.total = parseInt(data.data.total)
                    this.loading = false
                } else {
                    this.$message.error('查询失败')
                }
            })
        },

        // 重置
        reset() {
            this.$refs.searchForm.resetFields();
            this.refreshList(1, 1,1)
        },

        //切换状态
        setType(row) {
            row.status = row.status == 1 ? 0 : 1 //回显
            this.$axios(this.api.allCommon.commonWatermarkUpdateById, {
                id:row.id,
                status:row.status == 1 ? 0 : 1,
            }, 'put').then(data => {
                if (data && data.status) {
                    this.$message.success('状态修改成功')
                    this.refreshList('', 1)
                } else {
                    this.$message.error(data.msg)
                    this.refreshList('', 1)
                }
            })
        },

        //表格勾选数据
        selectionChangeHandle(val) {
            this.dataListSelect = val
        },

        // 列表排序
        sortChange(column) {
            if (column.order){
                let minSort = ''
                if (column.prop == 'createTime'){
                    minSort = column.order == "descending" ? 'desc' : (column.order == "ascending" ? 'asc' : '')
                    this.sort = 'create_time ' + minSort
                }
                if (column.prop == 'updateTime'){
                    minSort = column.order == "descending" ? 'desc' : (column.order == "ascending" ? 'asc' : '')
                    this.sort = 'update_time ' + minSort
                }
                this.refreshList(1,1)
            }else {
                this.sort = ''
                this.refreshList(1,1,1)
            }
        },

        //新增/编辑 水印
        addWatermark(row) {
            this.$refs.addWatermark.init(row)
        },

        //删除水印
        deleteWatermark(row) {
            let list = row ? [row] : this.dataListSelect
            if (list.length == 0) {
                this.$message.warning('请至少选择一条数据')
                return
            }
            let statusTrueList = []
            let ids = list.map(item => {
                if (item.status == 0) {
                    statusTrueList.push(item)
                }
                return item.id
            })
            if (statusTrueList.length != 0) {
                this.$message.warning('请先禁用后再删除！')
                return
            }
            this.$confirm(`您是否确认删除数据?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios(this.api.allCommon.commonWatermarkRemoveByIds, ids, 'post').then(data => {
                    if (data && data.status) {
                        this.$message.success('删除成功')
                        this.refreshList('', 1)
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            })
        },
    },
}
</script>

<style scoped>

</style>
